export const FILE_SIGNATURES = [
    { sig: '4D5A', type: 'Windows Executable (PE)' },
    { sig: '7F454C46', type: 'ELF Binary' },
    { sig: '25504446', type: 'PDF Document' },
    { sig: '89504E470D0A1A0A', type: 'PNG Image' },
    { sig: 'FFD8FF', type: 'JPEG Image' },
    { sig: '47494638', type: 'GIF Image' },
    { sig: '49492A00', type: 'TIFF (Little Endian)' },
    { sig: '4D4D002A', type: 'TIFF (Big Endian)' },
    { sig: '424D', type: 'BMP Image' },
    { sig: '504B0304', type: 'ZIP Archive / OpenXML' },
    { sig: '52617221', type: 'RAR Archive' },
    { sig: '1F8B', type: 'GZIP Archive' },
    { sig: '377ABCAF271C', type: '7-Zip Archive' },
    { sig: '00000100', type: 'ICO Icon' },
    { sig: '38425053', type: 'Photoshop (PSD)' },
    { sig: 'FD377A585A00', type: 'XZ Compression' },
    { sig: '3026B2758E66CF11', type: 'Windows Media (WMV/ASF)' },
    { sig: '52494646', type: 'AVI Video (RIFF)' },
    { sig: '1A45DFA3', type: 'Matroska Video (MKV/WebM)' },
    { sig: '464C4143', type: 'FLAC Audio' },
    { sig: '494433', type: 'MP3 Audio (ID3)' },
    { sig: '4F676753', type: 'OGG Container' },
    { sig: '52494646', type: 'RIFF Container (AVI/WAV)' },
    { sig: '00010000', type: 'TrueType Font (TTF)' },
    { sig: '4F54544F', type: 'OpenType Font (OTF)' },
    { sig: '774F4646', type: 'Web Open Font Format (WOFF)' },
    { sig: '774F4632', type: 'Web Open Font Format 2.0 (WOFF2)' },
    { sig: '53514C69', type: 'SQLite Database' },
    { sig: 'D0CF11E0', type: 'Microsoft Office (Legacy)' },
    { sig: '2321', type: 'Script (Shebang)' }
];
